import React, { PureComponent } from 'react';
import Dialog from '../dialog.jsx';
import { TermsMenu, SectionsMenu } from './menus.jsx';
import DestinationSections from '../destination_sections.jsx';
import Loading from '../loader';
import PropTypes from 'prop-types';
import R from 'ramda';
import { capitalize } from 'utils';

class CopyFrom extends PureComponent {
    static propTypes = {
        terms: PropTypes.any,
        sections: PropTypes.any,
        fromTerm: PropTypes.number,
        fromSection: PropTypes.number,
        includeClassMaterials: PropTypes.bool,
        includeMarkups: PropTypes.bool,
        includeTags: PropTypes.bool,
        setContent: PropTypes.func.isRequired,
    };

    constructor({
        includeClassMaterials,
        includeMarkups,
        includeTags,
        setContent,
    }) {
        super();
        Object.keys({
            includeClassMaterials,
            includeMarkups,
            includeTags,
        }).forEach(key => {
            this[`set${capitalize(key)}`] = ({
                currentTarget: { checked },
            }) => {
                setContent({ [key]: checked });
            };
        });
    }

    setFromTerm = fromTerm => {
        this.props.setContent({ fromTerm });
    };

    setFromSection = fromSection => {
        this.props.setContent({ fromSection });
    };

    render() {
        const {
            terms,
            sections,
            fromTerm,
            fromSection,
            includeClassMaterials,
            includeMarkups,
            includeTags,
        } = this.props;
        const hasSection = !!fromSection;

        let selectedTerm;
        if (fromTerm) {
            selectedTerm = terms.find(t => {
                return t.id === fromTerm;
            });
        }

        const sectionsForTerm = sections.filter(section => {
            return selectedTerm
                ? R.contains(section.id, selectedTerm.section_ids)
                : false;
        });

        return (
            <fieldset className="group copy-materials">
                <legend>
                    Copy From
                    <span className="aural">:</span>
                </legend>
                <fieldset
                    aria-live="polite"
                    aria-describedby="ariaCopyFromHeader"
                >
                    <legend className="aural">Term and Course Selection</legend>
                    <ul>
                        <li>
                            <label>Term</label>
                            <TermsMenu
                                terms={terms}
                                fromTerm={fromTerm}
                                onSelection={this.setFromTerm}
                            />
                        </li>
                        <li>
                            <label>Section</label>
                            <SectionsMenu
                                disabled={selectedTerm == null}
                                sections={sectionsForTerm}
                                fromSection={fromSection}
                                onSelection={this.setFromSection}
                            />
                        </li>
                    </ul>
                </fieldset>
                <fieldset aria-live="polite">
                    <legend className="aural">
                        <span>Items to copy. Check at least one.</span>
                    </legend>
                    <ul className="inline-list">
                        <li>
                            <input
                                type="checkbox"
                                checked={includeClassMaterials}
                                onChange={this.setIncludeClassMaterials}
                                id="includeMaterials"
                                disabled={!hasSection}
                            />
                            <label htmlFor="includeMaterials">
                                Uploads and Links
                                <span className="secondary">(Optional)</span>
                            </label>
                        </li>
                        <li>
                            <input
                                checked={includeMarkups}
                                onChange={this.setIncludeMarkups}
                                type="checkbox"
                                id="includeMarkups"
                                disabled={!hasSection}
                            />
                            <label htmlFor="includeMarkups">
                                My Notes
                                <span className="secondary">(Optional)</span>
                            </label>
                        </li>
                        <li>
                            <input
                                checked={includeTags}
                                onChange={this.setIncludeTags}
                                type="checkbox"
                                id="includeTags"
                                disabled={!hasSection}
                            />
                            <label htmlFor="includeTags">
                                Collections
                                <span className="secondary">(Optional)</span>
                            </label>
                        </li>
                    </ul>
                </fieldset>
            </fieldset>
        );
    }
}

export default class CopyMaterialsDisplay extends React.Component {
    static displayName = 'CopyMaterialsDisplay';

    static propTypes = {
        done: PropTypes.bool.isRequired,
        onClose: PropTypes.func.isRequired,
        onSave: PropTypes.func.isRequired,
        sections: PropTypes.any,
        terms: PropTypes.any,
        fromTerm: PropTypes.number,
        fromSection: PropTypes.number,
        selectedSections: PropTypes.array,
        includeClassMaterials: PropTypes.bool,
        includeMarkups: PropTypes.bool,
        includeTags: PropTypes.bool,
        setContent: PropTypes.func.isRequired,
    };

    setSelectedSections = selectedSections => {
        this.props.setContent({ selectedSections });
    };

    render() {
        if (this.props.done) {
            return (
                <Dialog
                    buttons={[]}
                    closeButton={false}
                    onClose={this.props.onClose}
                    title="Copy Materials"
                >
                    <Loading
                        superStyle={{ position: 'static' }}
                        message="Copying Materials..."
                    />
                </Dialog>
            );
        }

        const buttons = [];
        buttons.push({
            label: 'Cancel',
            dismiss: true,
        });
        buttons.push({
            label: 'Copy Materials',
            onClick: this.props.onSave,
            primary: true,
            disabled: this.props.done,
        });

        const { terms, fromSection } = this.props;

        const destinationSections = this.props.sections.filter(
            s => s.id !== fromSection
        );

        const destinationLegend = (
            <legend>
                <span className="aural">
                    Required: Check at least one section to
                </span>
                Copy to
            </legend>
        );

        return (
            <Dialog
                buttons={buttons}
                closeButton
                onClose={this.props.onClose}
                title="Copy Materials"
            >
                <div data-view-name="ManageContentView">
                    <p>All fields are required unless otherwise noted.</p>
                    <CopyFrom
                        terms={terms}
                        sections={this.props.sections}
                        includeClassMaterials={this.props.includeClassMaterials}
                        includeMarkups={this.props.includeMarkups}
                        includeTags={this.props.includeTags}
                        fromTerm={this.props.fromTerm}
                        fromSection={this.props.fromSection}
                        setContent={this.props.setContent}
                    />
                    <DestinationSections
                        legend={destinationLegend}
                        terms={terms}
                        sections={destinationSections}
                        selectedSections={this.props.selectedSections}
                        onChange={this.setSelectedSections}
                    />
                </div>
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/copy_materials_dialog/display.jsx